export function PayNowInvalidRoute() {
    window.location.href = window.location.href.substring(0, window.location.href.indexOf('/webpayment'));
    return null;
}

export default PayNowInvalidRoute;